/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionAccessDataReasonSchema = z.enum([
	'subscribed',
	'parent-subscribed',
	'demo',
	'external-invoicing',
	'fully-serviced',
	'exempt',
	'jobilla-staff',
	'subscription-inactive',
	'no-subscription',
])

export type SubscriptionAccessDataReasonSchema = z.infer<typeof subscriptionAccessDataReasonSchema>
